module.exports = __webpack_public_path__ + "img/14-eBind.fd4a0cc5.jpg";